import { render, staticRenderFns } from "./FilterAssets.vue?vue&type=template&id=0a05b569&"
import script from "./FilterAssets.vue?vue&type=script&lang=js&"
export * from "./FilterAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports